import 
    React,
    {
        useState
    }
from 'react'
import { Table, Pagination } from 'antd';

// Constant

// Components

// Handler
import { hookHDLR } from '../../../../handlers'

// Service
import { STYLES_UTIL, TIME } from '../../../../services/util'
import { useSelector } from 'react-redux';

const {
    useDeepEffect, usePrevious
} = hookHDLR

const {
    toTitleCase
} = STYLES_UTIL

const {
    parseDurationHRS
} = TIME

const FASummaryTable = (props) => {

    const {
        fuelUnitPrice,
        summary
    } = props

    const vid = useSelector(state => state.containers.v3.vehicleReportFuelAnalysis.selectedVID)

    const [ dataSrc, setDataSrc ] = useState({})

    const prevSummary = usePrevious(summary)
    const prevFuelUnitPrice = usePrevious(fuelUnitPrice)

    const BeautifyDisplay = (data, row) => {

        let res = ''

        const {
            unit
        } = row

        switch(unit) {
            case 'RM': {
                res = `${unit} ${data.toFixed(2)}`
                break;
            }
            case 'hr': {
                res = parseDurationHRS(data)
                break;
            }
            default: {
                res = `${data && data.toFixed(2)} ${unit}`
                break;
            }
        }

        return res
    }

    useDeepEffect(() => {

        if(
            summary
            &&
            Object.keys(summary)
            &&
            Object.keys(summary).length
            &&
            (
                
                prevSummary != summary
                ||
                prevFuelUnitPrice != fuelUnitPrice
            )
        ) {
           
            /**
             * Old Logic
             */
            // const newDS = []

            // summary
            // &&
            // Object.keys(summary)
            // &&
            // Object.keys(summary).length
            // &&
            // Object.keys(summary).map(ele => newDS.push({
            //     key: ele,
            //     ele: toTitleCase(ele.replace(/_/g, " ")),
            //     ...summary[ele]
            // }))

            // newDS.push({
            //     key: 'Fuel Cost',
            //     ele: 'Fuel Cost',
            //     total: summary.fuel_consumption.total * fuelUnitPrice,
            //     parking: summary.fuel_consumption.parking * fuelUnitPrice,
            //     moving: summary.fuel_consumption.moving * fuelUnitPrice,
            //     idling: summary.fuel_consumption.idling * fuelUnitPrice,
            //     unit: 'RM'
            // })


            let newDS = {}

            Object.keys(summary)?.length && Object.keys(summary).forEach(vid_i => {

                const sum = summary[vid_i]

                newDS[vid_i] = [
                    ...Object.keys(sum).map(ele => ({
                        key: ele,
                        ele: toTitleCase(ele.replace(/_/g, " ")),
                        ...sum[ele]
                    })),
                    {
                        key: 'Fuel Cost',
                        ele: 'Fuel Cost',
                        total: sum?.fuel_consumption.total * fuelUnitPrice,
                        parking: sum?.fuel_consumption.parking * fuelUnitPrice,
                        moving: sum?.fuel_consumption.moving * fuelUnitPrice,
                        idling: sum?.fuel_consumption.idling * fuelUnitPrice,
                        unit: 'RM'
                    }
                ]

            })

            setDataSrc(newDS)
        }

    }, [summary, fuelUnitPrice])

    const columns = [
        {
            title: 'Element',
            dataIndex: 'ele',
            key: 'ele'
        },
        {
            title: 'MOVING',
            dataIndex: 'moving',
            key: 'moving',
            render: (data, row) => BeautifyDisplay(data, row)
        },
        {
            title: 'IDLING',
            dataIndex: 'idling',
            key: 'idling',
            render: (data, row) => BeautifyDisplay(data, row)
        },
        {
            title: 'PARKING',
            dataIndex: 'parking',
            key: 'parking',
            render: (data, row) => BeautifyDisplay(data, row)
        },
        {
            title: 'TOTAL',
            dataIndex: 'total',
            key: 'total',
            render: (data, row) => BeautifyDisplay(data, row)
        }
    ]

    const [ page, setPage ] = useState(1)

    return (
        <>
            {
                dataSrc[`${vid}#${page}`]
                &&
                <>
                    <Table 
                        columns={columns} 
                        dataSource={dataSrc[`${vid}#${page}`]} 
                        pagination={false}
                    />
                    <Pagination 
                        defaultCurrent={1} total={Object.keys(dataSrc)?.length * 10} 
                        onChange={(e) => setPage(e)}
                        style={{ float: 'right', marginTop: '10px' }}
                    />
                </>

            }
        </>
    )
}

const MemorisedFASummaryTable = React.memo(FASummaryTable)

export default MemorisedFASummaryTable